import type React from "react";

import { Tooltip } from "@/design-system/Tooltip";

export interface TextTooltipProps {
  content: React.ReactNode;
  children?: React.ReactNode;
}

export function TextTooltip({ content, children }: TextTooltipProps): React.ReactNode {
  return (
    <Tooltip tooltip={content}>
      <span className="cursor-help underline-dotted">{children}</span>
    </Tooltip>
  );
}
